import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { SALONSBYUSER_FAILURE, SALONSBYUSER_REQUEST, SALONSBYUSER_SUCCESS } from 'salon/constants';

const listSalons = () => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    endpoint: 'salon/v2/list/',
    pinSafe: true,
    types: [SALONSBYUSER_REQUEST, SALONSBYUSER_SUCCESS, SALONSBYUSER_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default listSalons;
